import { useQuery, QueryFunction } from 'react-query';
import { getAllWorkTravelZones, WorkTravelZonesResponse, GetAllWorkTravelZonesParams } from '../../services/apiSLTP/sites/workTravelZones';

type UseWorkTravelZonesQueryOptions = {
    queries?: GetAllWorkTravelZonesParams;
};

const fetchWorkTravelZones: QueryFunction<WorkTravelZonesResponse> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseWorkTravelZonesQueryOptions];
    const { queries } = options || {};
    try {
        const zones = await getAllWorkTravelZones(queries);
        return zones;
    } catch (error) {
        throw new Error('An unexpected error occurred while fetching work travel zones');
    }
};

export const useWorkTravelZonesQuery = (options: UseWorkTravelZonesQueryOptions = {}) => {
    return useQuery(['WorkTravelZones', options], fetchWorkTravelZones);
};
